import React, { Component } from 'react';
import moment from 'moment';
import BorderedContainer from '../../../../../../components/BorderedContainer';
// Components
import SidePanelListItem from '../../../../../../components/SidePanelListItem';

import {
  Col,
  InfoTitle,
  ItemContent,
  RecipientsNumber,
  RecipientsNumberContainer,
  RecipientsNumberDescription,
  RecipientsNumberDescriptionUnavailable,
  RecipientsTrackingContainer,
  Row,
  SecondaryTitle,
  ShippingCompanyCnpj,
  ShippingCompanyDataContainer,
  ShippingCompanyIcon,
  ShippingCompanyLeftData,
  ShippingCompanyName,
  ShippingCompanyRightData,
  StrongText,
  StyledBorderedContainer,
  StyledButton,
  StyledTitleContainer,
  Title,
  TooltipParagraph,
} from './styles';
// CSS
import './styles.css';
import { rolesList } from '../../../../../../redux/auth';
import { connect } from 'react-redux';
import { getCustomerUsersList } from '../../../../../../redux/tracking-manager';
import { Tooltip } from '@material-ui/core';
import { QuestionCircle } from '../../components/AllowanceRelease/icons';
import Popup from '../../../../../../components/Popup';
import { formatCnpj } from '../../../../../../utils/parsers-formatters';
import defaultLogo from '../../../../../../assets/images/icn_truck-empresa-2.png';
import { isEmptyString } from '../../../../../../utils/validators';

const _hasRole = (role, userRoles) => userRoles.indexOf(role) !== -1;

class TrackingDetailsInfo extends Component {
  constructor(props) {
    super(props);

    this._onTrackingManager = this._onTrackingManager.bind(this);
    this.recipientsContainer = React.createRef();
  }

  componentDidMount() {
    this._onTrackingManager();
  }

  _onTrackingManager() {
    const { dispatch, data } = this.props;
    dispatch(getCustomerUsersList({ taxNumber: data.cnpjDest, page: 1 }));
  }

  render() {
    const {
      className,
      data,
      onTrackingManager,
      roles,
      customerUsersTotalError,
      customerUsersData
    } = this.props;

    const {
      orderDate,
      reDelivery,
      tms: { expectedDate, transitTimeDate, finishedDate, scheduled },
      origin,
      destination,
      shippingCompany,
      cte,
      carbonCredit,
      carbonEmission,
      predictedCarbonEmission,
    } = data;

    const deliveryMade = carbonEmission || carbonCredit;

    const deliveryNotMade =
      predictedCarbonEmission && !carbonEmission && !carbonCredit;

    const alreadyKnownTracking = window.localStorage.getItem('Luft/NewFeature/IntegratedTracking') === 'true'

    const isNoTracking =
      Number(customerUsersTotalError.split(' ').at(-1)) === 400;

    const numberOfRecipientsTracking =
      customerUsersData.filter((recipients) => recipients.HasTracking === true).length;

    const isCCABUser = (
      window.localStorage.getItem('Luft/CustomerService/CompanyName') ||
      window.localStorage.getItem('Luft/CompanyName')) === 'CCAB';
    const isGOPLANUser = window.localStorage.getItem('Luft/UserEmail') === 'gustavo.gambera@goplan.com.br';

    const isAdmin = _hasRole(rolesList.ADMINISTRATOR, roles);

    if (this.recipientsContainer.current && !alreadyKnownTracking) {
      setTimeout(() => {
        this.recipientsContainer.current.scrollIntoView({ behavior: 'smooth' });
      }, 350);
    }

    const destinationName = isEmptyString(reDelivery?.name) ? destination?.name : isEmptyString(destination?.name) ? reDelivery?.name : '-';
    
    return (
      <div className={`TrackingDetailsInfo ${className || ''}`}>
        <div className="TrackingDetailsInfo__nf-metabox-props">
          <InfoTitle>Dados do pedido</InfoTitle>

          <StyledBorderedContainer>
            <Row>
              <Col xs12 sm6 md12>
                <SidePanelListItem
                  className="TrackingDetailsInfo__detail-list-item"
                  title="Data de solicitação"
                >
                  {orderDate ? moment(orderDate).format('DD/MM/YYYY') : '-'}
                </SidePanelListItem>
                <SidePanelListItem
                  className="TrackingDetailsInfo__detail-list-item"
                  title="Prazo Contratado"
                >
                  {transitTimeDate
                    ? moment(transitTimeDate).format('DD/MM/YYYY')
                    : '-'}
                </SidePanelListItem>
                <SidePanelListItem
                  className="TrackingDetailsInfo__detail-list-item"
                  title="Agendamento"
                >
                  {scheduled && expectedDate
                    ? moment(expectedDate).format('DD/MM/YYYY')
                    : '-'}
                </SidePanelListItem>
                <SidePanelListItem
                  lastItem
                  className="TrackingDetailsInfo__detail-list-item"
                  title={finishedDate ? 'Entregue' : 'Previsão de entrega'}
                >
                  {finishedDate
                    ? moment(finishedDate).format('DD/MM/YYYY')
                    : expectedDate
                      ? moment(expectedDate).format('DD/MM/YYYY')
                      : '-'}
                </SidePanelListItem>
              </Col>
            </Row>
          </StyledBorderedContainer>

          <BorderedContainer>
            <Row>
              {shippingCompany.cnpj ? (
                <Col xs12 sm6 md12>
                  <SidePanelListItem
                    className="TrackingDetailsInfo__detail-list-item"
                    borderBottom
                  >
                    <ShippingCompanyDataContainer>
                      <ShippingCompanyLeftData>
                        <ShippingCompanyIcon src={shippingCompany?.icon || defaultLogo} alt='Logo' />
                      </ShippingCompanyLeftData>
                      <ShippingCompanyRightData>
                        {
                          shippingCompany.corporateName ? 
                            <ShippingCompanyName>{shippingCompany.corporateName}</ShippingCompanyName>
                          : null
                        }
                        <ShippingCompanyCnpj>{formatCnpj(shippingCompany.cnpj)}</ShippingCompanyCnpj>
                      </ShippingCompanyRightData>

                    </ShippingCompanyDataContainer>
                  </SidePanelListItem>
                </Col>
              ) : null}
             
              <Col xs12 sm6 md12>
                <SidePanelListItem
                  className="TrackingDetailsInfo__detail-list-item"
                  title="Destinatário"
                >
                  {destinationName}
                </SidePanelListItem>
              </Col>
              <Col xs12 sm6 md12>
                <SidePanelListItem
                  borderBottom
                  className="TrackingDetailsInfo__detail-list-item"
                  title="Cidade"
                >
                  {destination.city} - {destination.stateAbbr}
                </SidePanelListItem>
              </Col>

              <Col xs12 sm6 md12>
                <SidePanelListItem
                  className="TrackingDetailsInfo__detail-list-item"
                  title="Origem"
                >
                  {origin.city || ''} - {origin.stateAbbr}
                </SidePanelListItem>
              </Col>
              <Col xs12 sm6 md12>
                {reDelivery ? (
                  <SidePanelListItem
                    className="TrackingDetailsInfo__detail-list-item"
                    title="Destino"
                    hasReDelivery={reDelivery}
                    borderBottom
                  >
                    {reDelivery.city || ''} - {reDelivery.stateAbbr}
                  </SidePanelListItem>
                ) : (
                  <SidePanelListItem
                    className="TrackingDetailsInfo__detail-list-item"
                    title="Destino"
                    borderBottom
                  >
                    {destination.city || ''} - {destination.stateAbbr}
                  </SidePanelListItem>
                )}
              </Col>
              
              <Col xs12 sm6 md12>
                  <SidePanelListItem
                    className="TrackingDetailsInfo__detail-list-item"
                    title="Recebedor"
                    lastItem
                  >
                    {destination.receiverName || '-'}
                  </SidePanelListItem>
              </Col>
            </Row>
          </BorderedContainer>

          {deliveryMade ? (
            <StyledBorderedContainer>
              <Row>
                <Col xs12 sm6 md12>
                  <SidePanelListItem
                    className="TrackingDetailsInfo__detail-list-item"
                    title={<StyledTitleContainer>Pegada de Carbono <QuestionCircle /></StyledTitleContainer>}
                  >
                    <ItemContent>
                      <Title>CTE Referência</Title>
                      <div>{cte}</div>
                    </ItemContent>
                    <ItemContent>
                      <Title>Emissão de Carbono</Title>
                      <div>
                        <StrongText>{carbonEmission}</StrongText> T. CO2 EQ.
                      </div>
                    </ItemContent>
                    <ItemContent>
                      <SecondaryTitle>Valor a Compensar</SecondaryTitle>
                      <div>
                        <StrongText>*</StrongText> RCE
                      </div>
                    </ItemContent>
                  </SidePanelListItem>
                </Col>
              </Row>
            </StyledBorderedContainer>
          ): null}

          {deliveryNotMade ? (
            <StyledBorderedContainer>
              <Row>
                <Col xs12 sm6 md12>
                  <SidePanelListItem
                    className="TrackingDetailsInfo__detail-list-item"
                    title={<StyledTitleContainer>Pegada de Carbono <QuestionCircle /></StyledTitleContainer>}
                  >
                    <ItemContent>
                      <Title>CTE Referência</Title>
                      <div>{cte}</div>
                    </ItemContent>
                    <ItemContent>
                      <Title>Emissão de Carbono Prevista</Title>
                      <div>
                        <StrongText>{predictedCarbonEmission}</StrongText> T. CO2 EQ.
                      </div>
                    </ItemContent>
                  </SidePanelListItem>
                </Col>
              </Row>
            </StyledBorderedContainer>
          ): null}

          {(isAdmin || _hasRole(rolesList.RECIPIENT_TRACKING, roles)) &&
            (isCCABUser || isGOPLANUser) && (
              <StyledBorderedContainer emphasis={!alreadyKnownTracking} ref={this.recipientsContainer}>
                <Row>
                  <Col>
                    <RecipientsTrackingContainer>
                      <SidePanelListItem
                        className="TrackingDetailsInfo__detail-list-item"
                        title="Rastreio para destinatário"
                      />
                      <Tooltip
                        style={{ marginLeft: '7px' }}
                        title={
                          <TooltipParagraph>
                            O rastreio para destinatários permite que contatos
                            cadastrados acompanhem o rastreio dos seus pedidos em
                            tempo real.
                          </TooltipParagraph>
                        }
                        placement="top"
                        arrow
                      >
                        <div>
                          <QuestionCircle />
                        </div>
                      </Tooltip>
                    </RecipientsTrackingContainer>
                  </Col>
                </Row>
                {isNoTracking ? (
                  <RecipientsNumberContainer>
                    <RecipientsNumberDescriptionUnavailable>
                      Rastreio para destinatário indisponível.
                    </RecipientsNumberDescriptionUnavailable>
                  </RecipientsNumberContainer>
                ) : (
                  <RecipientsNumberContainer>
                    <RecipientsNumber>{numberOfRecipientsTracking}</RecipientsNumber>
                    <RecipientsNumberDescription>
                      Destinatários acompanhando seus pedidos.
                    </RecipientsNumberDescription>
                  </RecipientsNumberContainer>
                )}
                <Row>
                  <Col>
                    <StyledButton
                      disabled={isNoTracking}
                      skin="primary"
                      onClick={onTrackingManager}
                    >
                      Gerenciar rastreamento
                    </StyledButton>
                  </Col>
                </Row>
                {this.recipientsContainer.current && !alreadyKnownTracking && (
                  <Popup
                    anchorElProp={this.recipientsContainer.current}
                    open={!alreadyKnownTracking}
                    closeFunction={() => {
                      window.localStorage.setItem('Luft/NewFeature/IntegratedTracking', true);
                    }}
                    title={
                      <>
                        Agora seu destinatário <br />
                        consegue acompanhar seus<br />
                        pedidos em tempo real!
                      </>
                    }
                    description={
                      <>
                        Cadastre um contato para que<br />
                        ele receba um link de acesso e<br />
                        consulte o status do pedido!
                      </>
                    }
                  />
                )}
              </StyledBorderedContainer>
            )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    roles: state.auth.roles,
    customerUsersTotalError: state.trackingManager.customerUsersList.error || '',
    customerUsersData: state.trackingManager.customerUsersList.data || [],
  };
}

export default connect(mapStateToProps)(TrackingDetailsInfo);
